import DataNode from '../../../../interfaces/dataRoom/dataNode';
interface BreadcrumbProps {
  t: (key: string) => string; // Function to translate text
  folders: Array<FileNavigation>; // Array of folder objects
  onRootClick: () => void; // Function to handle click on DataRoom
  onFolderClick: (folder: FileNavigation) => void;
  fileName: string | null; // Current file name
}

export interface FileNavigation {
  id: string;
  name: string;
  node: DataNode
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  t,
  folders,
  onRootClick,
  onFolderClick,
  fileName,
}) => (
  <p className="ml-20 mt-20 mb-20 data-room__containers-pointers">
    <span onClick={onRootClick} className="data-room__pointers">{`${t(
      'f:pricing.dataRoom'
    )} `}</span>
    {folders.map((elem, i) => (
      <span
        key={elem.name?.concat(' ', i.toString())}
        className="data-room__pointers"
        onClick={() => onFolderClick(elem)}
      >
        {` > ${elem.name}`}
      </span>
    ))}
    {fileName && (
      <span className="data-room__pointers">{` > ${fileName}`}</span>
    )}
  </p>
);
export default Breadcrumb;
